// extracted by mini-css-extract-plugin
module.exports = {"TextShort":"News_TextShort___qKz5","TextLong":"News_TextLong__2B_Te"};